"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpError = exports.HttpError = void 0;
/**
 * Custom error class for HTTP responses with status codes
 */
class HttpError extends Error {
    constructor(message, statusCode) {
        super(message);
        this.name = 'HttpError';
        this.statusCode = statusCode;
    }
}
exports.HttpError = HttpError;
/**
 * Helper function to create common HTTP errors
 */
exports.createHttpError = {
    badRequest: (message = 'Bad Request') => new HttpError(message, 400),
    notFound: (message = 'Not Found') => new HttpError(message, 404),
    internalServerError: (message = 'Internal Server Error') => new HttpError(message, 500)
};
